<template>
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">高端总经销材料计划</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button v-if="mode === 'edit'" icon="form-advance" name="返回" @click="$router.go(-1)" />
        <form-button v-if="buttons.new" name="新建" @click="newCreate" />
        <form-button v-if="buttons.save" type="primary" name="保存" @click="saveData" />
        <form-button v-if="buttons.submit" icon="form-advance" name="提交" @click="changeStatus('SUBMIT')" />
        <form-button v-if="buttons.edit" name="编辑" @click="formEdit" />
        <form-button v-if="buttons.approve" name="审核通过" @click="changeStatus('APPROVE')" />
        <form-button v-if="buttons.reject" name="审核拒绝" @click="changeStatus('REJECT')" />
        <form-button v-if="buttons.cancel" name="取消" @click="changeStatus('CANCEL')" />
        <form-button v-if="buttons.revoke" name="撤回" @click="changeStatus('REVOKE')" />
      </div>
      <el-form
        ref="form"
        :disabled="isEdit"
        inline
        size="mini"
        label-width="100px"
        :model="conditions"
        :rules="rules"
        :show-message="false"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="材料计划编号">
              <el-input
                v-model="conditions.packpl_id"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="packpl_type" label="单据类型">
              <el-input value="高端总经销材料计划" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer" label="订单客户">
              <wly-input
                ref="custInput"
                v-model="conditions.customer"
                input-type="customer"
                :disabled="role.ROLE === 'WLY001'"
                clearable
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog($event, 'client')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select
                v-model="conditions.custypenumber"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.name1"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <!-- <el-input value="五粮液高端总经销" disabled /> -->
              <el-select
                v-model="conditions.zzfld00001h"
                placeholder=""
                type="select"
                :disabled="!customerInfo.yxdy.length"
                clearable
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="包材备用金">
              <el-input v-model="conditions.tby_dmbtr" disabled />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="预约">
              <el-checkbox v-model="conditions.preorder" true-label="1" false-label="0" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                placeholder=""
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 2 }"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col v-if="conditions.stacode === 'E006'" :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.audit_opinion"
                type="textarea"
                rows="2"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
                placeholder=""
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="部门">
              <el-input
                v-model="conditions.dept_name"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.datum"
                disabled
                value-format="yyyyMMdd"
                type="date"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据状态">
              <el-input
                v-model="conditions.status"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="材料计划明细" :custome-config="() => vxeShowCustom('xTable')">
        <template v-if="!isEdit" #button>
          <table-button name="add" tip="插入" @click="tableEvent('insert')" />
          <table-button name="delete" tip="删除" @click="tableEvent('del')" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #product_id="{row}">
            <wly-input
              v-model="row.product_id"
              size="mini"
              clearable
              :disabled="isEdit"
              input-type="product"
              :query-params="{ customerCode: conditions.customer }"
              @enter="handleEnter(...arguments,row)"
              @handleSuffixClick="openSelectDialog($event, 'product', row)"
            />
          </template>
          <template #planqty_box="{ row }">
            <el-input
              v-model.number="row.planqty_box"
              :disabled="isEdit"
              size="mini"
              clearable
              @keyup.enter.native="changeInput(row)"
            />
          </template>
          <template #planqty_bottle="{ row }">
            <el-input
              v-model.number="row.planqty_bottle"
              :disabled="isEdit"
              size="mini"
              clearable
              @keyup.enter.native="changeInput(row)"
            />
          </template>
          <template #remark="{row}">
            <el-input v-model="row.remark" size="mini" />
          </template>
          <template #operation="{row}">
            <div class="operation" @click="openSelectDialog($event, 'comList', row)">
              查看
            </div>
          </template>
          <template #versions="{row}">
            <el-select
              v-model="row.version"
              placeholder=""
              type="select"
              clearable
              size="mini"
              class="standard"
              :disabled="isEdit"
              @change="changeVersion($event,row.versions,row)"
            >
             <el-option
                v-for="item in row.versions"
                :key="item.version"
                :label="item.version"
                :value="item.version"
              />
            </el-select>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template v-if="!isEdit" #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.filename }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('history')">
        <vxe-grid
          ref="history"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>

    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog v-dialogDrag :title="dialogTitle" :visible.sync="showDialog" width="70%" :append-to-body="true">
      <template v-if="showDialog">
        <client-select v-if="showDialogType === 'client'" ref="dialogEdit" />
        <product-select
          v-else-if="showDialogType === 'product'"
          ref="dialogEdit"
          :is-auth="true"
          :query-params="{ customerCode: conditions.customer, mode: 'GD' }"
        />
        <ComponentList v-else-if="showDialogType === 'comList'" :rowDetail="componentRowDetail" ref="dialogEdit" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/utils/eventBus'

import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiSapSingleClientInfo } from '@/api/common'
import {
  apiGetMaterialPlanDetail,
  apiGetMaterialPlanSave,
  apiGetMaterialPlanUndo,
  apiGetMaterialPlanItemUpdate,
  apiGetMaterialPlanSub
} from '@/api/sap/material-plan'
import { sapDownloadFile } from '@/utils/frontExport'
import { formatSapFileSize } from '@/mixins/index'
import { mapGetters } from 'vuex'
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const ProductSelect = () => import('@/components/dialog/ProductSelect.vue')
const ComponentList = () => import('@/components/dialog/componentList.vue')
let packpl_item = 0
export default {
  components: {
    ClientSelect,
    ProductSelect,
    ComponentList
  },
  data() {
    const rules = {
      customer: [{ required: true, message: '请选择订单客户', trigger: 'change' }],
      packpl_type: [{ required: true, message: '请选择单据类型', trigger: 'change' }]
    }
    return {
      componentRowDetail: {},
      mode: 'add',
      rules,
      showDialogType: '',
      showDialog: false,
      errorList: [],
      dialogTitle: '',
      validRules: {
        product_id: [{ required: true }],
        planqty_box: [{ required: true }]
      },
      buttons: {
        approve: '',
        cancel: '',
        commit: '',
        edit: '',
        reject: '',
        revoke: '',
        save: 'X',
        submit: '',
        new: ''
      },
      formDis: false,
      conditions: {
        id: '',
        packpl_id: '', // 单据编号
        packpl_type: 'ZM03', // 单据类型
        customer: '', // 客户编号
        custypenumber: '', // 客户类型
        name1: '', // 客户名称
        zzfld00001h: '', // 营销单元
        uname: '', // 创建人
        datum: '', // 创建时间
        status: '新建', // 单据状态
        preorder: '0', // 是否预约
        dept_name: '',
        audit_opinion: '',
        remark: ''
      },
      currentRow: {},
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'packpl_item', title: '行号', width: 50, formatter: ({ cellValue }) => Number(cellValue) },
          { field: 'product_id', title: '产品编码', width: 200, slots: { default: 'product_id' }, editRender: {}, params: { bgEdit: true }},
          { field: 'description', title: '产品描述' },
          { field: 'wlybrand', title: '品牌' },
          { field: 'planqty_box', title: '计划数量（箱）', slots: { default: 'planqty_box' }, editRender: {}, params: { bgEdit: true }},
          { field: 'planqty_bottle', title: '计划数量（盒）', slots: { default: 'planqty_bottle' }, params: { bgEdit: true }},
          { field: 'planqty_ton', title: '计划数量（吨）' },
          { field: 'by_dmbtr', title: '包材保证金', width: 80 },
          { field: 'status', title: '状态', width: 80 },
          { field: 'version', title: '版本号', slots: { default: 'versions' }, params: { bgEdit: true }},
          { field: 'bom_code', title: 'BOM编码'},
          { field: 'operation', title: '组件列表', slots: { default: 'operation' }, params: { bgEdit: true }},
          { field: 'remark', title: '备注', slots: { default: 'remark' }, params: { bgEdit: true }}
        ],
        data: [],
        delData: []
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'filename', title: '附件名', width: 'auto', slots: { default: 'filename' }},
          { field: 'doc_type', title: '附件类型', width: 'auto' },
          { field: 'filelength', title: '附件大小', width: 'auto', formatter: ({ cellValue }) => formatSapFileSize(cellValue) },
          { field: 'zzfld00002d', title: '上传人', width: 'auto' },
          { field: 'zzfld00002d_dscr', title: '上传人姓名', width: 'auto' },
          { field: 'created_date', title: '上传日期', width: 'auto' },
          { field: 'created_time', title: '上传时间', width: 'auto' }
        ],
        data: [],
        delData: []
      },
      gridOptionsHistory: {
        columns: [
          { field: 'operationer', title: '操作员', width: 'auto' },
          { field: 'oper_name', title: '操作员姓名', width: 'auto' },
          { field: 'changin_date', title: '变更日期', width: 'auto' },
          { field: 'changin_time', title: '变更时间', width: 'auto' },
          { field: 'sys_approve', title: '审批系统', width: 'auto' },
          { field: 'oper_status_kt', title: '当前操作状态', width: 'auto' }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['role', 'customerInfo', 'userInfo']),
    isEdit() {
      if (this.conditions.status === '新建' || this.conditions.status === '已创建') {
        return this.formDis
      } else {
        return true
      }
    }
  },
  created() {
    // 材料计划单据类型
    this.getSelectDictDataOrigin('A0012')
    // 材料计划单据状态
    this.getSelectDictDataOrigin('A0013')
    this.getSelectDictDataOrigin('A0009')
    // 是否选项
    this.getSelectDictDataOrigin('B0099')

    // this.initOrg()

    if (this.$route.query.code) {
      this.conditions.packpl_id = this.$route.query.code
      this.mode = 'edit'
      this.handleQueryByCode()
    } else {
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}{m}{d}')
      this.conditions.uname = this.role.login_user
      this.conditions.dept_name = this.userInfo.deptName
      if (this.role.ROLE === 'WLY001') {
        const { info, high_yxdy } = this.customerInfo
        this.conditions.customer = info.partner
        this.conditions.name1 = info.name_org1
        this.conditions.custypenumber = info.zzfld000016
        high_yxdy.length && (this.conditions.zzfld00001h = high_yxdy[0].zzfld00001h)
        this.$set(this.selectDataOptions, 'orgList', high_yxdy)
      }
    }
  },
  mounted() {
    if (this.role.ROLE !== 'WLY001' && !this.$route.query.code) {
      this.conditions.customer = '19999999'
      setTimeout(() => {
        this.$refs.custInput.handleEnter('19999999')
      }, 1000)
    }
  },

  methods: {
    changeVersion(e,arg,row){
      let bomCode = null
      arg.forEach(ele => {
        if(ele.version === e){
          bomCode = ele.bom_code
        }
      });
      this.gridOptions.data.forEach((ele,idx) => {
        if(ele.product_id === row.product_id && ele.planqty_box === row.planqty_box){
          this.gridOptions.data[idx].bom_code = bomCode
        }
      });
    },
    // async initOrg() {
    //   const params = {
    //     USER_BP: this.$store.getters.role.USER_BP
    //   }
    //   const { DATA } = await apiGetOrgOrBase('', 3, params)
    //   this.$set(this.selectDataOptions, 'orgList', DATA)
    // },
    formEdit() {
      this.buttons = {
        approve: '',
        cancel: '',
        commit: '',
        edit: '',
        reject: '',
        revoke: '',
        save: 'X',
        submit: '',
        new: ''
      }
      this.formDis = false
    },
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
    // 文件下载
    downLoadFile(row) {
      sapDownloadFile(row.xcontent, row.filename)
    },
    // 提交：E003；撤回：E001；取消：E002  取消和撤回会回到新建状态初始化
    async changeStatus(mode) {
      try {
        const tip = {
          SUBMIT: '提交',
          CANCEL: '取消',
          REVOKE: '撤回'
        }

        if (Object.keys(tip).includes(mode)) {
          await this.$confirm(`确定要${tip[mode]}么`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        }
        this.loading = true
        if (['SUBMIT', 'APPROVE', 'REJECT'].includes(mode)) {
          this.submitData(mode)
        } else {
          this.undoData(mode)
        }
      } catch (error) {
        //
      }
      this.loading = false
    },
    // 新建
    newCreate() {
      this.$router.replace('/wly/material-plan/highend')
      eventBus.$emit('pageReload')
    },
    async changeInput(row) {
      this.errorList = []
      if (!row.product_id) return
      this.currentRow = row
      const params = { head: this.conditions, item: this.gridOptions.data, user_bp: this.role.USER_BP }
      const res = await apiGetMaterialPlanItemUpdate(params)

      if (res.msgtype === 'E') {
        this.errorList = [res.message]
        return
      }

      this.errorList = []
      // 更新
      const { data: { item, head }} = res

      Object.assign(this.conditions, head)
      this.gridOptions.data = item
    },
    // 保存
    saveData() {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          this.loading = true
          const params = {
            user_bp: this.role.USER_BP,
            item: this.gridOptions.data,
            head: this.conditions
          }
          if (this.conditions.packpl_type === 'ZM03') {
            params.attachment = this.gridOptionsFile.data
            params.history = this.gridOptionsHistory.data
          }
          this.errorList = []
          const res = await apiGetMaterialPlanSave(params)
          if (res?.msgtype === 'S') {
            const { head, item, attachment, history, button } = res
            this.$message.success(res.message)
            Object.assign(this.conditions, head)
            this.gridOptionsFile.data = attachment
            this.gridOptions.data = item
            this.gridOptionsHistory.data = history
            this.buttons = button
            this.formDis = true
          } else {
            this.errorList.push(res.message)
          }
          this.loading = false
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    // 撤销
    async undoData(mode) {
      const params = {
        mode,
        user_bp: this.role.USER_BP,
        item: this.filterDelData(),
        head: this.conditions,
        history: this.gridOptionsHistory.data,
        attachment: this.gridOptionsFile.data
      }
      this.errorList = []
      const res = await apiGetMaterialPlanUndo(params)
      if (res?.msgtype === 'S') {
        const { head, item, attachment, history, button } = res
        this.$message.success(res.message)
        Object.assign(this.conditions, head)
        this.gridOptionsFile.data = attachment
        this.gridOptions.data = item
        this.gridOptionsHistory.data = history
        this.buttons = button
        if (res.button.edit) this.formDis = true
      } else {
        this.errorList.push(res.message)
      }
    },
    // 提交
    async submitData(mode) {
      if (mode === 'REJECT') {
        const res = await this.$prompt('审核意见', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: value => {
            if (!value) {
              return false
            }
            return !!value.trim()
          },
          inputErrorMessage: '请输入审核意见！'
        })
        this.conditions.audit_opinion = res.value?.trim()
      }
      const params = {
        mode,
        user_bp: this.role.USER_BP,
        item: this.filterDelData(),
        head: this.conditions,
        history: this.gridOptionsHistory.data,
        attachment: this.gridOptionsFile.data
      }
      this.errorList = []
      const res = await apiGetMaterialPlanSub(params)
      if (res?.msgtype === 'S') {
        const { head, item, attachment, history, button } = res
        this.$message.success(res.message)
        Object.assign(this.conditions, head)
        this.gridOptionsFile.data = attachment
        this.gridOptions.data = item
        this.gridOptionsHistory.data = history
        this.buttons = button
        if (res.button.edit) this.formDis = true
      } else {
        this.errorList.push(res.message)
      }
    },
    filterDelData() {
      return [].concat(...this.gridOptions.data, this.gridOptions.delData)
    },
    // 根据id查询材料计划信息
    async handleQueryByCode() {
      this.loading = true
      try {
        const res = await apiGetMaterialPlanDetail({ iv_packpl_id: this.conditions.packpl_id, user_bp: this.role.USER_BP })
        Object.assign(this.conditions, res.head)
        this.gridOptions.data = res.item
        this.gridOptionsFile.data = res.attachment
        this.gridOptionsHistory.data = res.history
        this.buttons = res.button
        this.initCustome()
        if (res.button.edit) {
          this.formDis = true
        }
      } catch (error) {
        //
      }
      this.loading = false
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        user_bp: this.role.USER_BP,
        partner: this.conditions.customer
      }
      const { data } = await apiSapSingleClientInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data.high_yxdy)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    tableEvent(btn) {
      switch (btn) {
        case 'insert':
          this.insertRowData()
          break
        case 'del':
          this.removeRow()
          break
      }
    },
    async removeRow() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      if (checkedList.length === 0) {
        return
      } else if (checkedList.length === 1 || checkedList.length === this.gridOptions.data.length) {
        packpl_item = 0
      }

      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    // 插入明细表数据
    insertRowData() {
      const data = {}
      this.gridOptions.columns.filter(v => !v.type).forEach(v => {
        data[v.field] = ''
      })
      packpl_item += 10
      data.packpl_item = packpl_item
      data.customer = this.conditions.customer
      this.gridOptions.data.push(data)
    },
    // 打开窗口
    openSelectDialog(e, type, row) {
      e.target.blur()
      if(type === 'comList'){
        this.componentRowDetail = row
      }
      this.showDialogType = type
      this.dialogTitle = {
        client: '客户选择',
        product: '产品选择',
        comList: '组件列表'
      }[type]
      row && (this.currentRow = row)
      this.showDialog = true
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      if(this.showDialogType === 'comList'){
        this.showDialog = false
        return
      }
      this.$refs.dialogEdit.submitForm().then(res => {
        // console.log('submitForm', res)
        switch (this.showDialogType) {
          case 'product':
            this.handleProductSelect(res)
            break
          case 'client':
            this.conditions.customer = res.customerCode
            this.conditions.custypenumber = res.customerType
            this.conditions.name1 = res.customerName
            if (res.high_yxdy.length) {
              this.conditions.zzfld00001h = res.high_yxdy[0].zzfld00001h
            } else {
              this.conditions.zzfld00001h = ''
            }

            this.$set(this.selectDataOptions, 'orgList', res.high_yxdy)
            break
        }
        this.showDialog = false
      })
    },
    // 处理product选择
    handleProductSelect(product) {
      this.currentRow.product_id = product.productCode
      this.currentRow.description = product.SHORT_TEXT
      this.currentRow.wlybrand = product.BRAND_BQ_D
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      // console.log('handleEnter', type, data)

      switch (type) {
        case 'customer':
          this.conditions.customer = data.customerCode
          this.conditions.custypenumber = data.customerType
          this.conditions.name1 = data.customerName
          if (data.high_yxdy.length) {
            this.conditions.zzfld00001h = data.high_yxdy[0].zzfld00001h
          } else {
            this.conditions.zzfld00001h = ''
          }
          this.$set(this.selectDataOptions, 'orgList', data.high_yxdy)

          break
        case 'product':
          this.currentRow = row
          this.currentRow.product_id = data.productCode
          this.currentRow.description = data.SHORT_TEXT
          this.currentRow.wlybrand = data.BRAND_BQ_D
          break
      }
    },
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')

        const fileData = {
          filename: file.name,
          mimetype: file.raw.type,
          doc_type: file.raw.type,
          xcontent: strArr,
          filelength: file.size,
          zzfld00002d: _this.role.USER_BP,
          zzfld00002d_dscr: _this.role.login_user,
          created_time: new Date().toLocaleTimeString().replaceAll(':', ''),
          created_date: new Date().toLocaleDateString().replaceAll('/', '')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    parseTime(date) {
      return this.$utilsCommon.parseTime(new Date(date).getTime(), '{y}-{m}-{d}')
    },
    // 删除合同附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()

      checkedList.forEach(item => {
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 20px 20px;
  background: #ffffff;
}
.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
  .operation{
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/views/material-plan-manage/highendMaterialPlan.vue